import ProgressBar from 'react-bootstrap/ProgressBar';
import styled from 'styled-components';
import { BOLD_FONT_WEIGHT, DEFAULT_FONT_SIZE, PRIMARY_COLOR, SECONDARY_COLOR, SM_FONT_SIZE, SM_PADDING, XL_FONT_SIZE } from '../Common/StyleElement';

export const LoadImg = styled.img`
    width: 500px;
`

export const LoadLogo = styled.div`
    font-size: ${XL_FONT_SIZE};
    font-weight: ${BOLD_FONT_WEIGHT};
    padding-bottom: ${SM_PADDING};
`

export const LoadText = styled.p`
    font-size: ${SM_FONT_SIZE};
    font-weight: ${DEFAULT_FONT_SIZE};
`

export const LoadBar = styled(ProgressBar)`
    margin-bottom: ${SM_PADDING};
    .progress-bar {
        background-color: linear-gradient(90deg, ${PRIMARY_COLOR} 0%, ${SECONDARY_COLOR} 100%);;
    }
`